export default "__VITE_ASSET__235e1d7e__"